module.exports = __webpack_public_path__ + "static/media/rocket2.48d285a2.png";